// src/components/PromptEngineer.tsx

import React, { useEffect, useState } from 'react';

// Extend the global Window interface to include myChatWidget
declare global {
  interface Window {
    myChatWidget?: {
      load: (config: { assistantId: string; apiKey: string }) => void;
    };
  }
}

const PromptEngineer: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadChatWidget = () => {
      // Create a new script element
      const script = document.createElement('script');
      script.type = "text/javascript";
      script.src = "https://agentivehub.com/production.bundle.min.js";
      script.async = true;

      // Define the onload handler
      script.onload = () => {
        // Ensure the root element exists
        if (!document.getElementById('prompt-engineer-root')) {
          const root = document.createElement('div');
          root.id = 'prompt-engineer-root';
          document.body.appendChild(root);
        }

        // Initialize the chat widget
        if (window.myChatWidget && typeof window.myChatWidget.load === 'function') {
          try {
            window.myChatWidget.load({
              assistantId: 'c2412506-a71b-41bb-bef6-e53bcc8a6973', // Your PromptEngineer Assistant ID
              apiKey: '5e9fc760-d861-45eb-8095-72159f99cdf4',      // Your API Key
            });
            setIsLoading(false);
          } catch (err) {
            console.error(err);
            setError('Failed to initialize Prompt Engineer chat widget.');
            setIsLoading(false);
          }
        } else {
          setError('Chat widget not available.');
          setIsLoading(false);
        }
      };

      // Define the onerror handler
      script.onerror = () => {
        setError('Failed to load chat widget script.');
        setIsLoading(false);
      };

      // Insert the script into the DOM
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    };

    loadChatWidget();

    // Optional cleanup function
    return () => {
      // If necessary, remove the script or perform other cleanup tasks
    };
  }, []);

  if (isLoading) {
    return <div className="chatbot-loading">Loading Prompt Engineer chat bot...</div>;
  }

  if (error) {
    return <div className="chatbot-error">{error}</div>;
  }

  return (
    <div>
      <h1>Prompt Engineer ChatBot</h1>
      <div id="chatbot-container-prompt-engineer" className="fullscreen" />
    </div>
  );
};

export default PromptEngineer;
